import Vue from "vue";
import Component from "vue-class-component";
import useAuthUser from "@/hooks/useAuthUser";

type HookType = ReturnType<typeof useAuthUser>;

@Component({
  name: "WithAuthUser",
  setup() {
    const {
      authUser,
      authUserStrict,
      userVerified,
      userVerificationStatus,
      socialLogin,
      authorities,
      allowAccess,
      identityStatus,
      setVerificationStatus,
      setSocialLoginStatus,
      updateUser,
      getIdentityStatus,
    } = useAuthUser();
    return {
      authUser,
      authUserStrict,
      authUserVerified: userVerified,
      authUserVerificationStatus: userVerificationStatus,
      authUserSocialLogin: socialLogin,
      authUserAuthorities: authorities,
      authAllowAccess: allowAccess,
      authUserSetVerificationStatus: setVerificationStatus,
      authUserSetSocialLoginStatus: setSocialLoginStatus,
      authUserUpdate: updateUser,
      identityStatus,
      getIdentityStatus,
    };
  },
})
export default class WithAuthUser extends Vue {
  public authUser!: HookType["authUser"]["value"];
  public authUserStrict!: HookType["authUserStrict"]["value"];
  public authUserVerified!: HookType["userVerified"]["value"];
  public authUserVerificationStatus!: HookType["userVerificationStatus"]["value"];
  public authUserSocialLogin!: HookType["socialLogin"]["value"];
  public authUserAuthorities!: HookType["authorities"]["value"];
  public authAllowAccess!: HookType["allowAccess"]["value"];
  public identityStatus!: HookType["identityStatus"]["value"];
  public authUserSetVerificationStatus!: HookType["setVerificationStatus"];
  public authUserSetSocialLoginStatus!: HookType["setSocialLoginStatus"];
  public authUserUpdate!: HookType["updateUser"];
  public getIdentityStatus!: HookType["getIdentityStatus"];
}
